import React, { useContext } from "react";
import { v4 as uuidv4 } from "uuid";
import { RatesContext } from "../providers/RatesProvider";
import { useHistory } from "react-router-dom";
import { ratesRef } from "../firebase";
import { SettingsContext } from "../providers/SettingsProvider";
import { useEditMode } from "../customHooks/useEditMode";
import Footer from "./Footer";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import "../css/settingsLists.scss";
import { AuthContext } from "../providers/AuthProvider";
import { deleteDoc, doc, setDoc } from "firebase/firestore";

const Rates = () => {
  const { user } = useContext(AuthContext);
  const rates = useContext(RatesContext);
  const history = useHistory();

  const { currentRateNumber, incCurrentPrimaryNumber } =
    useContext(SettingsContext);
  const { inEditMode, toggleEditMode, isMarked, markItem, markedItems } =
    useEditMode();

  function editRate(rate) {
    let rateId = rate.uid;
    if (inEditMode) {
      markItem(rate);
    } else {
      let url = `/settings/rates/${rateId}`;
      history.push(url, { rate: rate });
    }
  }

  async function removeRates() {
    markedItems.forEach((uid) => {
      deleteDoc(doc(ratesRef, uid)).catch((err) => {
        console.error("Error deleting rates", err);
      });
    });

    toggleEditMode();
  }

  async function addRate() {
    const rateId = uuidv4();
    const blankRate = {
      uid: rateId,
      createdBy: user.uid,
      accessId: currentRateNumber,
      name: "",
      description: "",
      ratePerHour: 0,
      secondaryRate: 0,
    };

    history.push(`/settings/rates/${rateId}`, {
      rate: blankRate,
    });

    try {
      await setDoc(doc(ratesRef, rateId), blankRate);

      await incCurrentPrimaryNumber("rate");
    } catch (err) {
      return { success: false, error: err };
    }

    //return { success: true, error: null };
  }

  let showBin = inEditMode && markedItems.length > 0;
  return (
    <div className="ratesPage">
      <Footer back={true} title="Rates" backTo={"/"}>
        <button
          title="Edit"
          onClick={() => toggleEditMode(document.body)}
          className="adder"
        >
          <EditIcon style={{ fontSize: 25 }} />
        </button>
        {showBin ? (
          <button
            title="Delete Permanently"
            onClick={removeRates}
            className="adder"
          >
            <DeleteOutlinedIcon style={{ fontSize: 30 }} />
          </button>
        ) : (
          <button title="Add Rate" onClick={addRate} className="adder">
            <AddIcon style={{ fontSize: 30 }} />
          </button>
        )}
      </Footer>
      {/* <Footer title={"Rates"} back={true}>
        <button onClick={toggleEditMode} className="adder">
          ~
        </button>

        <button onClick={addRate} className="adder">
          @
        </button>
      </Footer> */}
      {/* <button className="addRate" onClick={addRate}>
        Add Rate
      </button>
      <button onClick={toggleEditMode}>
        edit mode <span>{String(inEditMode)}</span>
      </button> */}

      {/* {rates.length === 0 && <NoTimesheets />} */}

      <div className="settingsList">
        {rates.map((rate) => {
          let marked = isMarked(rate.uid);
          return (
            <button
              className="settingsCard"
              // style={marked ? markedItem : unmarkedItem}
              onClick={() => editRate(rate)}
              key={rate.uid}
            >
              <div className="cardHeader">
                <span>{rate.name}</span>
                <span></span>
                <span>
                  £{Number(rate.ratePerHour).toFixed(2)} ({rate.accessId})
                </span>
              </div>
              <div className="cardBody">{rate.description}</div>
              <div className="cardFooter"></div>
              {marked && <div className="markedPrimary" />}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Rates;
